import { Breadcrumb } from "react-bootstrap";

export function PageHeader({ title = "", url = "" }) {
  return (
    <header style={{ padding: "30px" }} className='jumbotron m-0 '>
      <div className='app-container'>
        <h1>{title.toUpperCase()}</h1>
        <Breadcrumb>
          <Breadcrumb.Item href='https://codev.utahcounty.gov/fire-marshal'>Home</Breadcrumb.Item>
          <Breadcrumb.Item href='url'>{title}</Breadcrumb.Item>
        </Breadcrumb>
      </div>
    </header>
  );
}
